import BaseService from './BaseService'

class CMSService extends BaseService {
  constructor () {
    super({path: 'cms'})
  }
}

export default new CMSService()
